/**
 * CloudAlerts — dispatcher for the Cloud 5.0 emergency alerts page.
 * Routes V2 to CloudAlertsPage, V1 to CurrentCloudAlerts.
 */

import { Navigate } from 'react-router-dom';
import { getSession } from '../services/session';
import CurrentCloudAlerts from './CurrentCloudAlerts.jsx';
import SessionReload from './component-assets/SessionReload.jsx';
import { compareRole, iAmHigherAuthority } from '../libs.jsx';
import { usePortalVersion } from '../contexts/PortalVersionContext.jsx';
import CloudAlertsPage from '../pages/events/alerts/CloudAlertsPage.jsx';

const CloudAlerts = (props) => {
    const { portalVersion } = usePortalVersion();
    const isV2 = portalVersion === 'v2';
    const dData = getSession();

    const alertContent = isV2
        ? <CloudAlertsPage fullscreen={props.fullscreen} />
        : <CurrentCloudAlerts fullscreen={props.fullscreen} />;

    return (compareRole('', dData?.userrole) || iAmHigherAuthority(0, dData?.role_weight)) ? (
        <>
            {dData?.migrated && <SessionReload />}
            {alertContent}
        </>
    ) : <Navigate to={'/'} />;
};

export default CloudAlerts;
